module.exports = __webpack_public_path__ + "static/media/checkbox.f475c3e0.svg";